/**
 * 【配送投诉页】
 */
import React from 'react';
import TableContent from './components/TableContent';
import PropTypes from 'prop-types';
import styles from './index.module.scss';
import { connect } from 'react-redux';
import moment from 'moment';
import { SearchBox, SearchItem } from '@/components/Layout';
import { setBreadcrumbPaths } from '@/reducers/home/actions';
import model from '@/reducers/aftersale/deliverycomplain/model';
import KeepAlive from '@/routes/KeepAlive';
import CreateTicket from '../modal/createTicket';
import { autoPageNum, autopageSize } from '@/assets/config';
import { XInput, XOKButton, XCancelButton, XDatePicker, XSelect, XInputNum } from '@/components/xqxc_ui';

class Main extends React.Component {
    state = {
        startDate: undefined,
        endDate: undefined,
        sourceType: {},
    }

    componentDidMount() {
        this.props.setBreadcrumbPaths(this.props.match); // 自动识别面包屑
        // 投诉类型
        this.props.getComplaintSourceTypeEnum({enumName: 'ComplaintSourceTypeEnum'});
    }

    // 表格操作
    _tableAction = (key, type, record) => {
        const { history } = this.props;
        switch (type) {
            // 查看详情
            case 'info':
                history.push({
                    pathname: `/home/aftersale/deliverycomplain/orderdetail/${key}`,
                });
                break;
            // 投诉处理
            case 'handle':
                history.push({
                    pathname: `/home/aftersale/deliverycomplain/handle/${key}`,
                });
                break;
            // 新建罚单
            case 'create':
                this.setState({ currentOpenMode: 'create', openModeParam: record.id });
                break;
        }
    }
    //打开弹窗
    _renderMode = () => {
        switch (this.state.currentOpenMode) {
            case 'create':
                return <CreateTicket title='新建罚单' data={{ id: this.state.openModeParam }} refresh={() => this._searchHandle('useCache')} visible={true} closeMode={this._closeMode} />;
            default:
                return null;
        }
    }

    // 关闭弹窗
    _closeMode = () => {
        this.setState({ currentOpenMode: '' });
    }
    // 表格分页
    _paginationChange = (pageSize, pageNum) => {
        this.setState({ pageSize, pageNum }, () => {
            this._searchHandle('useCache');
        });
    }

    // 查询
    _searchHandle = (useCache) => {
        const { pageNum, pageSize, startDate, endDate, sourceName, riderTel, riderName, sourceType } = this.state;
        const query = {
            sourceName,
            riderTel,
            riderName,
            startDate,
            endDate,
            sourceType: sourceType.code,
            pageNum: useCache == 'useCache' ? pageNum : autoPageNum, // 【第2步，当有useCache时使用当前分页状态，否则使用默认分页状态】
            pageSize: useCache == 'useCache' ? pageSize : autopageSize, // 【第2步，当有useCache时使用当前分页状态，否则使用默认分页状态】
        };
        this.props.getfindComplaints(query);
        KeepAlive.saveCache({ ...this.state, pageNum: query.pageNum, pageSize: query.pageSize }); // 【第3步，缓存查询状态】
    }

    // 重置
    _resetHandle = () => {
        this.setState({ startDate: undefined, endDate: undefined, sourceName: '', riderTel: '', riderName: '', sourceType: {}, pageNum: 1, pageSize: 10 }, () => {
            KeepAlive.saveResetFunc(this._searchHandle); // 【第4步：将是否调用重置交给KeepAlive控制】
        });
    }
    startDate = () => {
        this.setState({endDate: undefined });
    }
    disabledDate = (current) => {
        const { startDate } = this.state;
        let enddays = startDate && moment(startDate);
        return current && current < enddays && enddays.startOf('day');
    }
    render() {
        const { findComplaints, ComplaintSourceTypeEnum } = this.props;
        const { sourceName, riderTel, riderName, startDate, endDate, sourceType = {} } = this.state;

        return (
            <KeepAlive render={(state) => {
                if (!this.state.__aliveInit) {
                    this.setState({ ...state, __aliveInit: true }, () => {
                        this._searchHandle('useCache'); // 【第1步：调用查询接口初始化数据】
                    });
                }
            }}>
                <div className={`${styles.flexBoxContainer} ${styles.orderContainer}`}>
                    <SearchBox>
                        <SearchItem>
                            <XSelect
                                style={{ marginRight: 0 }}
                                selectStyle={{ width: 100 }}
                                label='投诉人'
                                placeholder='请选择'
                                renderData={ComplaintSourceTypeEnum}
                                dataIndex='value'
                                keyIndex='code'
                                value={sourceType.value}
                                showSearch={true}
                                bindThis={this}
                                bindName='sourceType'
                            />
                            <XInput
                                label=''
                                placeholder='请输入'
                                value={sourceName}
                                bindThis={this}
                                bindName='sourceName'
                            />
                        </SearchItem>
                        <SearchItem>
                            <XInput
                                label='被投诉人'
                                placeholder='请输入被投诉人'
                                value={riderName}
                                bindThis={this}
                                bindName='riderName'
                            />
                        </SearchItem>
                        <SearchItem>
                            <XInputNum
                                label='被投诉账号'
                                placeholder='请输入被投诉账号'
                                value={riderTel}
                                bindThis={this}
                                bindName='riderTel'
                                min={0}
                                precision={0}
                                maxLength={11}
                            />
                        </SearchItem>
                        <SearchItem>
                            <XDatePicker
                                label='投诉时间'
                                value={startDate}
                                bindThis={this}
                                bindName='startDate'
                                isFormat
                                showTime={false}
                                defaultTime='00:00:00'
                                onChange={this.startDate}
                            />
                            <XDatePicker
                                style={{ marginRight: 20 }}
                                label=''
                                value={endDate}
                                bindThis={this}
                                bindName='endDate'
                                isFormat
                                showTime={false}
                                defaultTime='23:59:59'
                                disabledDate={this.disabledDate}
                            />
                        </SearchItem>
                        <SearchItem>
                            <XOKButton
                                label='查询'
                                onClick={this._searchHandle}
                            />
                            <XCancelButton
                                label='重置'
                                onClick={this._resetHandle}
                            />
                        </SearchItem>
                    </SearchBox>
                    <TableContent renderData={findComplaints} tableAction={this._tableAction} paginationChange={this._paginationChange} />
                    {this._renderMode()}
                </div>
            </KeepAlive >
        );
    }
}

Main.propTypes = {
    history: PropTypes.object,
    setBreadcrumbPaths: PropTypes.func, 
    getfindComplaints: PropTypes.func,
    findComplaints: PropTypes.object,
    getComplaintSourceTypeEnum: PropTypes.func,
    ComplaintSourceTypeEnum: PropTypes.array
};

const mapStateToProps = (state) => ({
    findComplaints: state.deliverycomplain.findComplaints,
    ComplaintSourceTypeEnum: state.deliverycomplain.ComplaintSourceTypeEnum
});

export default connect(mapStateToProps, { setBreadcrumbPaths, ...model.actions })(Main);
